import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import { useTranslation } from 'react-i18next';

import { trackClick } from '@/lib/tagging';

import { useResetPasswordEmailManager } from '../hooks/useResetPasswordEmailManager';

export function ResendEmail() {
  const { handleResendEmail } = useResetPasswordEmailManager();
  const { t } = useTranslation('resetPasswordEmail');

  const buttonText = t('resetPasswordForm.buttonText');

  const onResendClick = async () => {
    trackClick('recovery/email/resend');
    await handleResendEmail();
  };

  return (
    <CtaContainer stack>
      <Cta type="secondary" onClick={onResendClick}>
        {buttonText}
      </Cta>
    </CtaContainer>
  );
}
